/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as api from '../api';
import * as types from '../constants/actions';
import { makeAsyncAction, makeAsyncResetAction } from '../utils/async_utils';

export const fetchReservations = makeAsyncAction(
    types.FETCH_RESERVATIONS,
    (resIds) => () => api.getReservations(resIds),
    'reservations'
);

export const createReservations = makeAsyncAction(
    types.CREATE_RESERVATIONS,
    (reservations, recaptchaOptions) => () =>
        api.createReservations(reservations, recaptchaOptions),
    'reservations'
);

export const updateReservation = makeAsyncAction(
    types.UPDATE_RESERVATION,
    (reservation) => () => api.updateReservation(reservation),
    'reservations'
);

export const resetReservations = makeAsyncResetAction(types.RESET_RESERVATIONS);
